import {Component} from '@angular/core';
export const PREFIX = '--';

@Component({
  selector: 'tart-sass-helper',
  template: `<div></div>`,
})
export class SassHelperComponent {
  private _smMaxWidth: string;
  private _mdMaxWidth: string;
  private _lgMaxWidth: string;
  constructor() {
    this._smMaxWidth = this.readProperty('max-width-sm');
    this._mdMaxWidth = this.readProperty('max-width-md');
    this._lgMaxWidth = this.readProperty('max-width-lg');
  }

  get smMaxWidth(): string {
    return this._smMaxWidth;
  }

  get mdMaxWidth(): string {
    return this._mdMaxWidth;
  }

  get lgMaxWidth(): string {
    return this._lgMaxWidth;
  }

  public readProperty(name: string): string {
    const bodyStyles = window.getComputedStyle(document.body);
    return bodyStyles.getPropertyValue(PREFIX + name).trim().replaceAll('"', '');
  }

}
